import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M12 22c2.98 0 1.168-4.432 3-6.5 1.563-1.765 7-.957 7-3.5 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10Zm0 0c2.98 0 1.168-4.432 3-6.5 1.563-1.765 7-.957 7-3.5 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M12.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM7.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M9.5 18.327a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }